import { getStore, postStore } from '@/utils/http/http'
import { VZAN_STORE_BASE_URL, LIVEPAY_URL } from '@/utils/http/baseUrl'

// 请求方法封装对象
const companyManagerApi = {
  /**
   * @method GET-根据分公司id获取分公司信息
   */
  getCurrentCompanyInfo(params) {
    return getStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getCurrentCompanyInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-负责人分公司切换列表展示
   */
  getCompanyList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/companyList`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-负责人区域列表
   */
  getCompanyManagerRegionList(params) {
    return getStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/regionList`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-添加客户跟进
   */
  cmAddFollowUp(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/addFollowUp`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-客户列表导出
   */
  cmExportCustomerManageInfo(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/exportCustomerManageInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-H5完成商机任务
   */
  cmFinishStep(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/finishStep`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-客户列表
   */
  getCmCustomerManageInfo(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getCustomerManageInfo`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-客户详情
   */
  getCmCustomerDetail(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getCustomerDetail`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-门店报表-商品统计
   */
  getCmProductStatList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getProductStatList`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-门店报表-商品统计-聚合
   */
  getCmProductStatSum(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getProductStatSum`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-H5代理详情-未观看用户
   */
  getCmTopicNoViewList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getTopicNoViewList`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-业绩报表-总览
   */
  getCmTotalOrderPerformance(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/getTotalOrderPerformance`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-健康观众列表
   */
  getCmHealthUserList(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/healthUserList`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-健康观众列表导出
   */
  cmHealthUserListExport(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/healthUserListExport`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-所有商机
   */
  cmListOpportunity(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/listOpportunity`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-用户观看栏目
   */
  cmListUserColumn(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/listUserColumn`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-H5商机步骤详情
   */
  cmOpportunityStepDetail(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/opportunityStepDetail`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-业绩报表
   */
  cmPageDayOrderPerformanceData(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/pageDayOrderPerformanceData`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-客户跟进列表
   */
  cmPageFollowUp(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/pageFollowUp`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-用户观看栏目
   */
  cmUserWatchColumn(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/userWatchColumn`,
      params,
      false
    )
  },
  /**
   * @method POST-分公司负责人-观看直播
   */
  cmWatchRecord(params) {
    return postStore(
      `${VZAN_STORE_BASE_URL}/health/v1/h5/store/company-manager/watchRecord`,
      params,
      false
    )
  },
}

// 命名导出所有方法
export const {
  getCurrentCompanyInfo,
  getCompanyList,
  cmAddFollowUp,
  cmExportCustomerManageInfo,
  cmFinishStep,
  getCmCustomerManageInfo,
  getCmCustomerDetail,
  getCmProductStatList,
  getCmProductStatSum,
  getCmTopicNoViewList,
  getCmTotalOrderPerformance,
  getCmHealthUserList,
  cmHealthUserListExport,
  cmListOpportunity,
  cmListUserColumn,
  cmOpportunityStepDetail,
  cmPageDayOrderPerformanceData,
  cmPageFollowUp,
  cmUserWatchColumn,
  cmWatchRecord,
} = companyManagerApi

// 默认导出封装对象
export default companyManagerApi
